// extracted by mini-css-extract-plugin
export var title = "J_b";
export var titleWhite = "J_bT";
export var variant1 = "J_bD";
export var variant2 = "J_bF";